<template>
  <div class="notice-item">
    <AcceptContractDocAlert
      v-for="(contractDoc, i) in hire.latestContract.contractDocs"
      :key="i"
      :contract-doc="contractDoc"
      :is-complete="isComplete"
    />
  </div>
</template>

<script setup>
import gql from 'graphql-tag'

import AcceptContractDocAlert from '@/components/compliances/alerts/AcceptContractDocAlert.vue'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})
</script>

<script>
export const fragments = {
  hire: gql`
    fragment AcceptContractDocsAlertHire on Hire {
      latestContract {
        contractDocs {
          localId
          docType
          docTypeHelp
          docTypeName
          pdfUrl
        }
      }
    }
  `,
}
</script>
